import React from 'react'
import HeaderSectionContainer from '../containers/HeaderSection/HeaderSection.container'
import UnsubscribeSectionContainer from '../containers/Unsubscribe/Unsubscribe.container'
import BrandLayout from '../components/Layouts/BrandLayout'
import { Container, Root, Wrapper } from './Unsubscribe.styles'

/**
 * The Unsubscribe' page.
 */
const Unsubscribe = () => {
  return (
    <Root>
      <BrandLayout header={<HeaderSectionContainer align="center" brandMargin="0" brandSize="medium" />}>
        <Container>
          <Wrapper>
            <UnsubscribeSectionContainer />
          </Wrapper>
        </Container>
      </BrandLayout>
    </Root>
  )
}

export default Unsubscribe
